import React from "react";
import cx from "classnames";
import { Icon } from "components/Icon/Icon";
import { IconButton } from "components/IconButton/IconButton";
import s from "../Styles.module.scss";
import { ProductImage } from "components/ProjectTree/components/Configuration/ProductImage";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";

export const RightControls = ({ nodeId }: { nodeId?: string }) => (
  <div className="d-flex flex-row align-items-center justify-content-end">
    <IconButton
      id={`editFolder${nodeId}`}
      icon="pencil-light"
      iconClassName="icon-16"
      className="px-2 border-0"
    />
    <IconButton
      id={`duplicateFolder${nodeId}`}
      icon="duplicate-light"
      iconClassName="icon-16"
      className="px-2 border-0"
    />
    <IconButton
      id={`copyFolder${nodeId}`}
      icon="copy-light"
      iconClassName="icon-16"
      className="px-2 border-0"
    />
    <IconButton
      id={`downloadModal${nodeId}`}
      icon="arrow-down-bracket-light"
      iconClassName="icon-16"
      className="px-2 border-0"
      disabled={true}
    />
    <IconButton
      id={`deleteFolder${nodeId}`}
      icon="trash-can-light"
      iconClassName="icon-16"
      className="px-2 border-0"
    />
  </div>
);

export const DraggedFolder = ({ node }: { node: NodeApi }) => {
  if (!node || !node.data) {
    return null;
  }

  const title = node.data?.folderName || node.data?.productName;

  const pimId = node.data?.pimId || null;
  const nodeChildren = node.children;

  const hasChildren = nodeChildren && nodeChildren.length > 0;

  return (
    <div
      className={cx(
        "d-flex flex-row h-100 border border-info bg-blue-50 rounded-1",
        s.dragPreview,
      )}
      style={{ width: "75vw" }}
    >
      <div className="d-flex flex-row align-items-center p-2 border-3">
        <div>
          <Icon
            iconName="grip-dots-vertical"
            className="icon-12 cursor-pointer text-blue-300"
          />
        </div>

        {pimId && (
          <ProductImage
            pimId={pimId}
            productImagesDisabled={false}
            productName={title}
            width={64}
            height={64}
          />
        )}
        {hasChildren && (
          <Icon
            iconName="chevron-right-regular"
            className={cx(
              "icon-16  mx-1 cursor-pointer text-gray-700 opacity-20 position-relative",
              s.folderIcon,
            )}
          />
        )}
        <IconButton
          testId="addFolderButton"
          icon="plus-regular"
          iconClassName="icon-12"
          className={cx("mx-1 p-0_5 bg-white position-relative z-1")}
          disabled={true}
        />
      </div>
      <div className="py-2 d-flex align-items-center flex-grow-1">
        <span
          className={cx("fw-bold fs-md text-truncate", s.title)}
          data-testid="folder-title"
        >
          {title}
        </span>
      </div>
      <RightControls />
    </div>
  );
};
